import Client from '../client';
import BaseService from '../baseService/baseService';
import { AxiosResponse } from 'axios';

const EmpreendimentosExcluidosService = {
    salvarParametrosExcel(fileRequest: any) {
        return BaseService.conectarEndpoint(fileRequest, 'flex/empreendimentos-excluidos/excel', 'excelEmpreendimentoExcluido');
    },
    baixarParametrosExcel(): Promise<void | AxiosResponse<any>> {
        return Client.getBlob('flex/empreendimentos-excluidos/excel');
    },
    deletarParametrosExcel(request: any) {
        return BaseService.conectarEndpoint(request, 'flex/empreendimentos-excluidos/excel/deletar', 'excelEmpreendimentoExcluidoDeletar');
    },
    reenviarParametrosExcel(): Promise<void | AxiosResponse<any>> {
        return Client.post('flex/empreendimentos-excluidos/eventGrid', {});
    },
};

export default EmpreendimentosExcluidosService;
